import ApiBaseUrl from './http-api-base-url'
import axios from 'axios';

export default ({ requiresAuth = false } = {}) => {
  const options = {};
  options.baseURL = ApiBaseUrl();

  if (requiresAuth) {
    options.headers = {
      Authorization: ''
    };
  }

  const instance = axios.create(options);

  // Interceptor: apply baseURL only if URL does NOT start with http
  instance.interceptors.request.use(config => {
    if (/^https?:\/\//i.test(config.url)) {
      // absolute URL → do NOT prepend baseURL
      config.baseURL = '';
    }
    return config;
  });

  instance.interceptors.response.use(
    response => response,
    error => Promise.reject(error)
  );

  return instance;
};
